/** Client-side idle logout for authenticated applicants (affordable is long). */
export const IDLE_LOGOUT_MS = 15 * 60 * 1000;
/** Show "still there?" warning this long before logout. */
export const IDLE_WARN_BEFORE_MS = 60 * 1000;

export const IDLE_ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "wheel",
] as const;

export type IdlePhase = "active" | "warning" | "expired";

export function idlePhaseAt(
  nowMs: number,
  lastActivityMs: number,
  idleMs: number = IDLE_LOGOUT_MS,
  warnBeforeMs: number = IDLE_WARN_BEFORE_MS
): IdlePhase {
  const idleFor = nowMs - lastActivityMs;
  if (idleFor >= idleMs) return "expired";
  if (idleFor >= idleMs - warnBeforeMs) return "warning";
  return "active";
}

export function msUntilIdlePhaseChange(
  nowMs: number,
  lastActivityMs: number,
  idleMs: number = IDLE_LOGOUT_MS,
  warnBeforeMs: number = IDLE_WARN_BEFORE_MS
): number {
  const idleFor = nowMs - lastActivityMs;
  const warnAt = idleMs - warnBeforeMs;
  if (idleFor < warnAt) return warnAt - idleFor;
  if (idleFor < idleMs) return idleMs - idleFor;
  return 0;
}

/** Post-logout landing so Sign In can restore the application via returnTo. */
export function idleLogoutReturnPath(): string {
  return "/error/401?reason=idle";
}
